import React from "react";
import { UseMainQueryProps } from "./type";
import { useMainQuery } from "./useMainQuery";
import { useMain } from "./useMain";
import MainView from "./MainView";

const MainPage = () => {
  const queries: UseMainQueryProps = useMainQuery();
  const hook = useMain(queries);

  return <MainView queries={queries} hook={hook} />;
};
export default React.memo(MainPage);
